export enum ConsolidationStatus {
  Open = "open",
  Closed = "closed",
  Sealed = "sealed",
  Completed = "completed",
  Cancelled = "cancelled",
}
